import 'instantsearch.css/themes/satellite.css';
import { Link, useLocation, useParams } from 'react-router-dom';
import { MdArrowForwardIos } from 'react-icons/md';
import RestexInformes from '../../components/restez-informes/RestexInformes';
import { useMemo, useState } from 'react';
import Loader from '../../components/Loader/Loader';
import {
  Configure,
  Hits,
  InstantSearch,
  Pagination,
  RangeInput,
  SortBy,
  ClearRefinements,
  Menu,
  SearchBox,
} from 'react-instantsearch';

import './style.css';
import { useWishList } from '../../contexts/WishListContext';
import {
  Panel,
  StatePagination,
  MyRefinementList,
  Product,
  instantSearchOnStateChange,
  TyreFilters,
  RimFilters,
  VehicleFilters,
  PartFilters,
  MyCurrentRefinements,
} from '../../components/products/ProductList';
import { history } from 'instantsearch.js/es/lib/routers';
import { instantMeiliSearch } from '@meilisearch/instant-meilisearch';
import { PRIMARY_BRANDS } from '../../helpers/shopHelper';
import { productAttributeSlugDictionnaryForUrl } from '../../utils/productHelper';
import { Helmet } from 'react-helmet-async';

const hitsPerPage = 30;

const getProductType = (globalType) => {
  switch (globalType) {
    case 'Véhicules':
      return 'vehicules';
    case 'Pneus':
      return 'pneus';
    case 'Jantes':
      return 'jantes';
    case 'Pièces détachées':
      return 'pieces';
  }
};

const Catalogue = () => {
  const { searchClient } = useMemo(
    () =>
      instantMeiliSearch(
        process.env.VITE_MEILISEARCH_HOST_URL,
        process.env.VITE_MEILISEARCH_API_KEY,
        {
          finitePagination: true,
        },
      ),
    [],
  );
  const { isItemInWishList } = useWishList();
  const [currentFilters, setCurrentFilters] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const params = useParams();
  const location = useLocation();

  const getSortConfig = () => {
    if (
      currentFilters.globalType === 'Jantes' ||
      currentFilters.globalType === 'Pneus'
    ) {
      return [
        {
          label: 'Par défaut',
          value: 'products_index',
        },
        {
          label: 'Prix croissant',
          value: 'products_index:price:asc',
        },
        {
          label: 'Prix décroissant',
          value: 'products_index:price:desc',
        },
        {
          label: "Par date d'ajout",
          value: 'products_index:created_at:desc',
        },
      ];
    } else {
      return [
        {
          label: 'Par défaut',
          value: 'products_index',
        },
        {
          label: 'Prix croissant',
          value: 'products_index:price:asc',
        },
        {
          label: 'Prix décroissant',
          value: 'products_index:price:desc',
        },
        {
          label: 'Kilométrage croissant',
          value: 'products_index:mileage:asc',
        },
        {
          label: 'Kilométrage décroissant',
          value: 'products_index:mileage:desc',
        },
        {
          label: "Par date d'ajout",
          value: 'products_index:created_at:desc',
        },
      ];
    }
  };

  const getAttributeSlug = (name) => {
    return productAttributeSlugDictionnaryForUrl[name];
  };

  const getAttributeName = (slug) => {
    return Object.keys(productAttributeSlugDictionnaryForUrl).find(
      (key) => slug === productAttributeSlugDictionnaryForUrl[key],
    );
  };

  const pushOrInit = (arr, value) => {
    if (typeof arr !== 'object') {
      arr = [];
    }
    arr.push(value);
    return arr;
  };

  const productTypeValues = {
    vehicules: 'Véhicules',
    pneus: 'Pneus',
    jantes: 'Jantes',
    pieces: 'Pièces détachées',
  };

  const routing = {
    router: history({
      cleanUrlOnDispose: false,
      createURL({ qsModule, routeState, location }) {
        const urlParts = location.href.match(/^(.*?)\/catalogue/);
        const baseUrl = `${urlParts ? urlParts[1] : ''}/`;
        let cataloguePath = 'catalogue';

        // Construction du chemin selon le format de la regex
        // /(?:(vehicules|pneus|jantes|pieces)\/)?(?:marque-(\w+)\/?)?(.[^\/]+)?/
        let type = routeState.menu?.globalType
          ? Object.keys(productTypeValues).find(
              (key) => productTypeValues[key] === routeState.menu.globalType,
            )
          : null;

        if (type === 'vehicules') {
          const vehicleType = routeState.menu?.type;
          if (vehicleType) {
            type +=
              vehicleType === 'used'
                ? '-d-occasion'
                : vehicleType === 'accidented'
                  ? '-accidentes'
                  : '';
          }
        }

        const brand = routeState.refinementList?.brand?.[0];

        const model = routeState.refinementList?.globalModel?.[0];

        // Construction du chemin
        const arrayPath = [
          type,
          brand ? `marque-${brand}` : null,
          model,
        ].filter((item) => !!item);
        cataloguePath += arrayPath.length > 0 ? `/${arrayPath.join('/')}` : '';

        // Paramètres de requête
        const queryParameters = {};

        // Paramètres de base (q, page, sortBy)
        if (routeState.q) {
          queryParameters.q = routeState.q;
        }

        if (routeState.page && routeState.page !== 1) {
          queryParameters.page = routeState.page;
        }

        if (routeState.sortBy) {
          queryParameters.sortBy = routeState.sortBy;
        }

        // Ajout des autres attributs qui ne sont pas dans l'URL principale
        Object.entries(routeState.refinementList || {}).forEach(
          ([key, values]) => {
            // Ignorer les attributs déjà inclus dans le chemin principal
            if (key !== 'brand' && key !== 'globalModel' && values.length > 0) {
              const attributeSlug = getAttributeSlug(key);
              if (attributeSlug) {
                queryParameters[attributeSlug] = values;
              }
            }
          },
        );

        const queryString = qsModule.stringify(queryParameters, {
          addQueryPrefix: true,
          arrayFormat: 'repeat',
        });

        return `${baseUrl}${cataloguePath}${queryString}`;
      },
    }),
    stateMapping: {
      stateToRoute(uiState) {
        const indexUiState = uiState['products_index'];

        return {
          q: indexUiState.query,
          refinementList: indexUiState.refinementList,
          menu: indexUiState.menu,
          page: indexUiState.page,
          sortBy:
            indexUiState.sortBy &&
            indexUiState.sortBy.includes('products_index:')
              ? indexUiState.sortBy.replace('products_index:', '')
              : indexUiState.sortBy,
        };
      },
      routeToState(routeState) {
        const refinementList = routeState?.refinementList ?? {};
        const menu = routeState?.menu ?? {};
        let sortBy = routeState?.sortBy;
        const routeParams = params['*'];

        if (routeParams) {
          const match = routeParams.match(
            /(?:(vehicules-d-occasion|vehicules-accidentes|vehicules|pneus|jantes|pieces)\/?)?(?:marque-(\w+)\/?)?(.[^\/]+)?/,
          );
          let globalType = match[1] ? decodeURIComponent(match[1]) : null;
          let vehicleType;
          if (
            globalType === 'vehicules-d-occasion' ||
            globalType === 'vehicules-accidentes'
          ) {
            vehicleType =
              globalType === 'vehicules-d-occasion'
                ? 'used'
                : globalType === 'vehicules-accidentes'
                  ? 'accidented'
                  : null;
            globalType = 'vehicules';
          }
          const brand = match[2] ? decodeURIComponent(match[2]) : null;
          const model = match[3] ? decodeURIComponent(match[3]) : null;

          let modelAttributeName = 'globalModel';

          if (globalType) {
            menu['globalType'] = productTypeValues[globalType];
          }
          if (vehicleType) {
            menu['type'] = vehicleType;
          }
          if (brand) {
            refinementList['brand'] = pushOrInit(
              refinementList['brand'],
              brand,
            );
          }
          if (model) {
            refinementList[modelAttributeName] = pushOrInit(
              refinementList[modelAttributeName],
              model,
            );
          }
        }

        const searchParams =
          location.search
            ?.split('?')[1]
            ?.split('&')
            ?.map((param) => ({
              attribute: param.split('=')[0],
              value: decodeURIComponent(param.split('=')[1]),
            })) || [];

        searchParams.forEach(({ attribute, value }) => {
          const attributeName = getAttributeName(attribute);
          if (attributeName && value) {
            refinementList[attributeName] = pushOrInit(
              refinementList[attributeName],
              value,
            );
          }
        });

        if (
          !!routeState.sortBy &&
          !routeState.sortBy.includes('products_index')
        ) {
          sortBy = 'products_index:' + routeState.sortBy;
        }

        setCurrentFilters({
          ...refinementList,
          ...menu,
        });
        return {
          ['products_index']: {
            query: routeState.q,
            menu: menu,
            refinementList: refinementList,
            page: routeState.page,
            sortBy: sortBy,
          },
        };
      },
    },
  };

  const getTitle = () => {
    let title = 'Produits';
    if (currentFilters?.globalType) {
      title = currentFilters.globalType;
    }
    if (currentFilters?.brand) {
      title += ` de la marque ${currentFilters.brand}`;
    }
    if (currentFilters?.globalModel) {
      title += ` - ${currentFilters.globalModel}`;
    }
    return title;
  };

  return (
    <>
      {(currentFilters?.globalType ||
        currentFilters?.brand ||
        currentFilters?.globalModel) && (
        <Helmet>
          <title>{getTitle()} - Stop Pièces Auto</title>
        </Helmet>
      )}
      {!!location.search && (
        <Helmet>
          <meta name="robots" content="noindex, follow" />
        </Helmet>
      )}
      <div className="wrapper flex flex-col gap-[8px] mb-[40px]">
        <div className="content flex gap-[12px] md:gap-[24px] items-center w-full py-[16px] 1400:px-0 px-[16px]">
          <p className="text-dark cursor-pointer transition">
            <Link to="/">Accueil</Link>
          </p>
          <MdArrowForwardIos className="text-[#9EA5A7] text-[12px]" />
          <p className="text-[#9EA5A7] cursor-pointer transition">
            <Link to="/catalogue">Catalogue</Link>
          </p>
        </div>
        <div className="search-result-cards content flex flex-col md:gap-[24px] sm:gap-[15px] lg:gap-[30px] md:py-[15px] 1400:px-0 px-[16px]">
          <InstantSearch
            searchClient={searchClient}
            indexName={'products_index'}
            routing={routing}
            onStateChange={({ uiState, setUiState }) =>
              instantSearchOnStateChange(
                { uiState, setUiState },
                setCurrentFilters,
                [currentPage, setCurrentPage],
              )
            }
            future={{
              preserveSharedStateOnUnmount: true,
              persistHierarchicalRootCount: true,
            }}
          >
            <Loader instantSearch />
            <Configure hitsPerPage={hitsPerPage}></Configure>

            <div className="flex-col gap-[12px] lg:gap-[24px] hidden md:flex">
              <h1 className="font-clash text-[40px] sm:text-[50px] leading-[1] 900:text-[80px] 900:leading-[34px] font-[600] text-dark ">
                Notre catalogue
              </h1>
            </div>
            <div className="w-full flex flex-col md:flex-row gap-[35px] md:gap-[20px] lg:gap-[48px]">
              {/* Filters  */}
              <div className="w-full bg-gray p-[12px] rounded-[8px] md:p-0 md:bg-transparent md:max-w-[250px] 900:max-w-[300px] flex flex-col gap-[12px] 900:gap-[24px]">
                <div>
                  {currentFilters && Object.keys(currentFilters).length > 0 && (
                    <ClearRefinements
                      translations={{
                        resetButtonText: 'Réinitialiser les filtres',
                      }}
                    />
                  )}
                  <SearchBox placeholder="Rechercher" className="mb-6" />
                  <Panel header="Type d'article">
                    <Menu attribute="globalType" sortBy={['count:desc']} />
                  </Panel>
                  <div hidden={currentFilters?.globalType}>
                    <Panel header="Marque">
                      <MyRefinementList
                        attribute="brand"
                        operator="and"
                        searchable={true}
                        searchablePlaceholder="Marque"
                        showMore={true}
                        priorityValues={PRIMARY_BRANDS}
                        currentFilters={currentFilters}
                      />
                    </Panel>
                    <Panel
                      header="Modèle"
                      hidden={!currentFilters || !currentFilters.brand}
                    >
                      <MyRefinementList
                        attribute="globalModel"
                        operator="and"
                        searchable={true}
                        searchablePlaceholder="Modèle"
                        showMore={true}
                        currentFilters={currentFilters}
                      />
                    </Panel>
                    <Panel header="Prix">
                      <RangeInput
                        attribute="price"
                        precision={0}
                        translations={{
                          submitButtonText: 'Valider',
                          separatorElementText: ' à ',
                        }}
                      />
                    </Panel>
                    <Panel header="Motorisation">
                      <MyRefinementList
                        attribute="energy"
                        searchable={false}
                        operator="or"
                        searchablePlaceholder="Motorisation"
                        showMore={true}
                        showMoreLimit={100000}
                        limit={10}
                        currentFilters={currentFilters}
                      />
                    </Panel>
                  </div>
                  <VehicleFilters
                    currentFilters={currentFilters}
                    hidden={currentFilters?.globalType !== 'Véhicules'}
                  />
                  <PartFilters
                    currentFilters={currentFilters}
                    hidden={currentFilters?.globalType !== 'Pièces détachées'}
                  />
                  <RimFilters
                    currentFilters={currentFilters}
                    hidden={currentFilters?.globalType !== 'Jantes'}
                  />
                  <TyreFilters
                    currentFilters={currentFilters}
                    hidden={currentFilters?.globalType !== 'Pneus'}
                  />
                </div>
              </div>
              {/* Products  */}
              <div className="w-full flex flex-col gap-[15px]">
                <div className="flex flex-col gap-[12px] lg:gap-[48px] md:hidden">
                  <h1 className="font-clash text-[40px] sm:text-[50px] leading-[1] 900:text-[80px] 900:leading-[64px] font-[600] text-dark">
                    Notre catalogue
                  </h1>
                </div>
                {/* pRODUCTS tOP bAR  */}
                <div className="flex w-full items-center justify-between">
                  <div className="flex gap-[24px] items-center"></div>
                  <div className="flex items-center gap-[24px]">
                    <div className="flex gap-[8px] font-[400] text-blue items-center">
                      <img
                        src="/menu-blue.png"
                        alt=""
                        className="max-w-[16px] max-h-[16px]"
                      />
                      Tri
                      <SortBy items={getSortConfig()}></SortBy>
                    </div>
                    <div className="w-[1px] h-[24px] bg-[#9ea5a7c4]" />
                    <div className="text-[#9EA5A7] hover:text-dark cursor-pointer transition">
                      <StatePagination hitsPerPage={hitsPerPage} />
                    </div>
                  </div>
                </div>
                <MyCurrentRefinements />
                <Hits
                  classNames={{
                    root: 'w-full flex-1 grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-3 gap-x-[12px] 1200:gap-x-[24px] gap-y-[24px] 1200:gap-y-[48px]',
                    list: 'relative contents',
                  }}
                  hitComponent={({ hit }) => (
                    <Product
                      title={hit.title}
                      price={hit.price}
                      liked={isItemInWishList(hit)}
                      src={hit.mainImage}
                      id={hit.refSource}
                      type={getProductType(hit.globalType)}
                      product={hit}
                    />
                  )}
                />
                <Pagination className="Pagination" />
              </div>
            </div>
          </InstantSearch>
        </div>
      </div>
      <RestexInformes />
    </>
  );
};

export default Catalogue;
